import 'slick-carousel';

import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"


jQuery(($) => {

    $(".slider-columns").slick({
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        fade: true,
        cssEase: 'linear'
    });

    if ($(".recent-episodes").length > 0) {

        $('.prev-next').removeClass('hidden');

        var $recentSlider = $(".slider-recent").slick({
            dots: false,
            infinite: false,
            variableWidth: true,
            slidesToShow: 1,
            rows: 0,
            speed: 300
        });

        var position = $('.recent-episodes h2').offset();
        $('.slick-track').css('left', position.left + 'px');

        $('.carousel-prev').on('click', function(){
            $recentSlider.slick('slickPrev');

            if($('.slick-next').hasClass('slick-disabled')){
                $('.carousel-next').addClass('disabled');
            }else{
                $('.carousel-next').removeClass('disabled');
            }
            if($('.slick-prev').hasClass('slick-disabled')){
                $('.carousel-prev').addClass('disabled');
            }else {
                $('.carousel-prev').removeClass('disabled');
            }
        });

        $('.carousel-next').on('click', function(){
            $recentSlider.slick('slickNext');

            if($('.slick-next').hasClass('slick-disabled')){
                $('.carousel-next').addClass('disabled');
            }else{
                $('.carousel-next').removeClass('disabled');
            }
            if($('.slick-prev').hasClass('slick-disabled')){
                $('.carousel-prev').addClass('disabled');
            }else {
                $('.carousel-prev').removeClass('disabled');
            }
        });
    }

});
